module.exports = __webpack_public_path__ + "static/media/ic_schedule.eaa7eec2.svg";